var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vuestic-tag-group"},_vm._l((_vm.value),function(item,index){return _c('vuestic-tag',{key:index,attrs:{"name":item.name || item,"type":_vm.type || item.type,"removable":_vm.removable},on:{"remove":function($event){return _vm.removeTag(index)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }